import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { api, authService } from '../services/api';
import { toast } from 'sonner';
import { User, Lock, Save } from 'lucide-react';

export const ParametresPage = () => {
  const currentUser = authService.getCurrentUser();
  const [nom, setNom] = useState(currentUser?.nom || '');
  const [prenom, setPrenom] = useState(currentUser?.prenom || '');
  const [savingProfile, setSavingProfile] = useState(false);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    if (!nom.trim() || !prenom.trim()) {
      toast.error('Nom et prénom sont obligatoires');
      return;
    }
    setSavingProfile(true);
    try {
      const res = await api.put('/auth/profile', { nom: nom.trim(), prenom: prenom.trim() });
      // Update local storage
      const userData = { ...currentUser, nom: res.data.nom, prenom: res.data.prenom };
      sessionStorage.setItem('eva_user', JSON.stringify(userData));
      toast.success('Profil mis à jour');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setSavingProfile(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    setSavingPassword(true);
    try {
      await api.post('/auth/change-password', { new_password: newPassword });
      toast.success('Mot de passe modifié');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setSavingPassword(false);
    }
  };

  return (
    <Layout title="Paramètres" breadcrumbs={['Accueil', 'Paramètres']}>
      <div className="max-w-2xl space-y-6">
        {/* Profile Section */}
        <div className="eva-card" data-testid="profile-section">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
              <User size={20} className="text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Informations personnelles</h3>
              <p className="text-sm text-slate-400">{currentUser?.email}</p>
            </div>
          </div>

          <form onSubmit={handleSaveProfile} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="eva-label">Prénom</label>
                <input
                  type="text"
                  value={prenom}
                  onChange={(e) => setPrenom(e.target.value)}
                  className="eva-input"
                  required
                  data-testid="settings-prenom-input"
                />
              </div>
              <div>
                <label className="eva-label">Nom</label>
                <input
                  type="text"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  className="eva-input"
                  required
                  data-testid="settings-nom-input"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={savingProfile}
              className="eva-btn-primary flex items-center gap-2"
              data-testid="save-profile-button"
            >
              <Save size={16} />
              {savingProfile ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </form>
        </div>

        {/* Password Section */}
        <div className="eva-card" data-testid="password-section">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-amber-500/15 rounded-lg flex items-center justify-center">
              <Lock size={20} className="text-[#F59E0B]" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Changer le mot de passe</h3>
              <p className="text-sm text-slate-400">Minimum 6 caractères</p>
            </div>
          </div>

          <form onSubmit={handleChangePassword} className="space-y-4">
            <div>
              <label className="eva-label">Nouveau mot de passe</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="eva-input"
                placeholder="Minimum 6 caractères"
                required
                data-testid="settings-new-password"
              />
            </div>
            <div>
              <label className="eva-label">Confirmer le mot de passe</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="eva-input"
                placeholder="Confirmez votre mot de passe"
                required
                data-testid="settings-confirm-password"
              />
            </div>
            <button
              type="submit"
              disabled={savingPassword}
              className="eva-btn-primary flex items-center gap-2"
              data-testid="save-password-button"
            >
              <Lock size={16} />
              {savingPassword ? 'Modification...' : 'Modifier le mot de passe'}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};
